function mtInitReveals() {
  var els = document.querySelectorAll('.mt-reveal, .mt-reveal-stagger');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mt-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15 }
  );
  els.forEach(function (el) { observer.observe(el); });
}

function mtInitGaleria(root) {
  var mains = root.querySelectorAll('[data-mt-galeria-principal]');
  var thumbs = root.querySelectorAll('[data-mt-miniatura]');
  if (!mains.length || !thumbs.length) return;
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var url = thumb.getAttribute('data-mt-miniatura');
      mains.forEach(function (main) { main.src = url; });
      thumbs.forEach(function (t) { t.classList.remove('mt-activa'); });
      thumb.classList.add('mt-activa');
    });
  });
}

function mtInitGalerias() {
  document.querySelectorAll('[data-mt-galeria]').forEach(mtInitGaleria);
}

function mtInitVariantes() {
  document.querySelectorAll('[data-mt-producto-form]').forEach(function (root) {
    var dataEl = root.querySelector('[data-mt-variantes-json]');
    if (!dataEl) return;
    var variants;
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    var selects = root.querySelectorAll('[data-mt-opcion]');
    var idInput = root.querySelector('[data-mt-variant-id]');
    var precioActual = root.querySelector('[data-mt-precio-actual]');
    var precioAnterior = root.querySelector('[data-mt-precio-anterior]');
    var boton = root.querySelector('[data-mt-add-boton]');

    function moneda(cents) {
      return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: window.Shopify && Shopify.currency ? Shopify.currency.active : 'EUR' });
    }

    function actualizar() {
      var seleccion = Array.from(selects).map(function (s) { return s.value; });
      var match = variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === seleccion[i]; });
      });
      if (!match) return;
      if (idInput) idInput.value = match.id;
      if (precioActual) precioActual.textContent = moneda(match.price);
      if (precioAnterior) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          precioAnterior.textContent = moneda(match.compare_at_price);
          precioAnterior.style.display = '';
        } else {
          precioAnterior.style.display = 'none';
        }
      }
      if (boton) {
        boton.disabled = !match.available;
        boton.textContent = match.available ? boton.getAttribute('data-mt-texto-disponible') : boton.getAttribute('data-mt-texto-agotado');
      }
    }

    selects.forEach(function (s) { s.addEventListener('change', actualizar); });
  });
}

document.addEventListener('DOMContentLoaded', function () {
  mtInitReveals();
  mtInitGalerias();
  mtInitVariantes();
});
